import { Checkbox } from "@mui/material";
import GoalValueControl from "./GoalValueControl";

export default function GoalRow({ goal, value, onChange }) {
  const target = goal.goalValue || 0;
  const completed = target > 0 && (value || 0) >= target;

  return (
    <div className="flex items-center justify-between py-2 border-b border-terakkiBorder last:border-b-0">
      <div className="flex-1">
        <div className="text-base font-SemiBold text-terakkiPrimary">{goal.label}</div>
        {goal.isCustom === false && (
          <div className="text-xs text-terakkiNeutral">Genel</div>
        )}
      </div>
      <div className="flex items-center gap-3">
        <GoalValueControl value={value} onChange={onChange} />
        <span className="text-sm text-terakkiNeutral w-14 text-right">/ {target}</span>
        <Checkbox checked={completed} disabled />
      </div>
    </div>
  );
}
